/**
 * API client de ConfiguracaoComercial (Bloco B Fase 4).
 *
 *   GET   /api/comercial/configuracoes        list (uma por unidade)
 *   GET   /api/comercial/configuracoes/{id}
 *   PATCH /api/comercial/configuracoes/{id}   gestor: comercial:configurar
 */

const PREFIXO = "/api/comercial/configuracoes";

export function listarConfiguracoes(request, opts) {
  return request(PREFIXO, opts);
}

export function obterConfiguracao(request, id) {
  return request(`${PREFIXO}/${id}`);
}

export function atualizarConfiguracao(request, id, dados) {
  return request(`${PREFIXO}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

/** Atalho: pega a primeira configuracao (UN1 hoje) — fallback null. */
export async function configuracaoDefault(request) {
  try {
    const payload = await listarConfiguracoes(request);
    const items = Array.isArray(payload) ? payload : payload?.results || [];
    return items[0] || null;
  } catch {
    return null;
  }
}
